import React from 'react';
interface FeatureCardProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  image?: string;
  link?: string;
  className?: string;
  variant?: 'default' | 'bordered' | 'elevated' | 'filled';
}
const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  icon,
  image,
  link,
  className = '',
  variant = 'default'
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case 'bordered':
        return 'border border-gray-100 hover:border-primary-300 backdrop-blur-xl bg-white/80';
      case 'elevated':
        return 'backdrop-blur-xl bg-white/80 border border-gray-100';
      case 'filled':
        return 'bg-gradient-to-br from-gray-50 to-white hover:from-white hover:to-gray-50 border border-gray-100';
      default:
        return 'border border-gray-100 hover:border-gray-200 backdrop-blur-xl bg-white/80';
    }
  };
  const cardContent = <>
      {image && <div className="mb-4 overflow-hidden rounded-lg" data-id="element-71">
          <img src={image} alt={title} className="w-full h-48 object-cover transition-transform duration-300 hover:scale-105" data-id="element-72" />
        </div>}
      {icon && <div className="mb-4 text-primary-500" data-id="element-73">{icon}</div>}
      <h3 className="text-xl font-semibold mb-2 bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent" data-id="element-74">
        {title}
      </h3>
      <p className="text-gray-600" data-id="element-75">{description}</p>
    </>;
  return link ? <a href={link} className={`block p-6 rounded-lg transition-all duration-300 hover:scale-[1.02] ${getVariantClasses()} ${className}`} data-id="element-76">
      {cardContent}
    </a> : <div className={`p-6 rounded-lg transition-all duration-300 hover:scale-[1.02] ${getVariantClasses()} ${className}`} data-id="element-77">
      {cardContent}
    </div>;
};
export default FeatureCard;